export const persistedStateLocalStorageKey = 'yammer.persistedState.keys';

export const getPersistedStateConfigKeys: () => string[] = () => {
  const persistedStateFromLocalStorage = window.localStorage.getItem(persistedStateLocalStorageKey);

  return persistedStateFromLocalStorage ? persistedStateFromLocalStorage.split(',') : [];
};

export const clearPersistedStateConfigKeys: () => void = () => {
  const storedKeys: string[] = getPersistedStateConfigKeys();
  storedKeys.forEach((key) => {
    window.localStorage.removeItem(key);
  });
};

export const setPersistedStateConfigKeys: (configKey: string) => void = (configKey) => {
  const storedKeys: string[] = getPersistedStateConfigKeys();
  const persistConfigKey = `persist:${configKey}`;
  if (!storedKeys.find((key) => key === persistConfigKey)) {
    storedKeys.push(persistConfigKey);
    window.localStorage.setItem(persistedStateLocalStorageKey, storedKeys.toString());
  }
};
